import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiPartnerService } from '@app/api/api-partner.service';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-form-storeshop',
  templateUrl: './form-storeshop.component.html',
  styleUrls: ['../listorder.component.css']
})
export class FormStoreshopComponent implements OnInit {
  //Form
  showForm = true;
  loadingForm = false;
  id : string = '';
  item = {};
  formStoreShop = this.fb.group({
    name: [''],
    statusid: ['']
  });

  constructor(
    private partnerService : ApiPartnerService,
    public route : ActivatedRoute,
    public router: Router,
    public fb : FormBuilder
  ) { }

  ngOnInit() {
    this.loadStart();
  }

  loadStart(){
    let id = this.route.snapshot.paramMap.get('id');
    if(id != null){
      this.id = id;
      this.detailStoreShop(this.id);           
    }
  }

  detailStoreShop(id:any){
    return this.partnerService.GetDetailStoreshop(id).subscribe((output: any) => { 
      this.item = output.data; 

      if(output.status===false){
        this.showForm = false;
      }
      //console.log(this.item); 
    });    
  }
  
  saveStoreShop() {
    //console.log(this.formStoreShop.value);
    this.loadingForm = true;
    this.partnerService.PostCreateStoreShop(this.formStoreShop.value)
      .subscribe((response: any) => {        
        if (response.status == true) {
          this.alertsukses("Prosioning Ditambahkan.");
          this.router.navigate(['/adminecommerce/storeshop-form/'+response.data.id]);
        } 
        else {        
          this.alertgagal(response.message);
        }
        this.loadingForm = false;
      }      
    );
  }

  editStoreShop(item) {
    //console.log(this.formStoreShop.value);

    this.partnerService.PostUpdateStoreShop(item.id,this.formStoreShop.value)
      .subscribe((response: any) => {        
        if (response.status == true) {
          this.alertsukses("Prosioning Diperbarui.");
          //this.router.navigate(['/adminecommerce/storeshop-form/'+response.data.id]);
        } 
        else {        
          this.alertgagal(response.data.message);
        }        
      }      
    );
  }

  alertsukses(item:any){
    swal({
      title: "Sukses!",
      text: item,
      icon: "success",
      button: "OK"
    }).then(function() {
        
    });
  }
  alertgagal(item:any){

    swal({
      title: "Gagal!",
      text: item,
      icon: "error",
      button: "OK",
    });
  }
}
